module.exports = [
  {
    type: "text",
    name: "firstName",
    label: "First Name *",
    value: "",
    required: true,
  },
  {
    type: "text",
    name: "lastName",
    label: "Last Name *",
    value: "",
    required: true,
  },
  {
    type: "email",
    name: "email",
    label: "Email *",
    value: "",
    required: true,
  },
  {
    type: "tel",
    name: "phone",
    label: "Phone *",
    value: "",
    required: true,
  },
  {
    type: "text",
    name: "postcode",
    label: "Postcode *",
    value: "",
    required: true,
  },
  {
    type: "select",
    name: "timeframeToPurchase",
    label: "Timeframe To Purchase *",
    value: "",
    required: true,
    options: [
      {
        label: "Select a timeframe",
        value: "",
        disabled: true,
        selected: true,
      },
      { label: "Now", value: "Now" },
      { label: "0-3 months", value: "0-3 months" },
      { label: "3-6 months", value: "3-6 months" },
      { label: "6-9 months", value: "6-9 months" },
      { label: "9-12 months", value: "9-12 months" },
      { label: "12+ months", value: "12+ months" },
      { label: "Information Only", value: "Information Only" },
      { label: "Next Release", value: "Next Release" },
    ],
  },
  {
    type: "checkbox",
    name: "optIn",
    label: "I want to receive further information via email",
    value: "",
    required: false,
  },
  {
    type: "checkbox",
    name: "terms",
    label: `I have read and understood the <a class="underline" href="#" target="_blank">privacy policy</a> *`,
    value: "",
    required: true,
  },
];
